module.exports = __webpack_public_path__ + "static/media/logo-ko-albanymed.158be4f4.png";